<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    <p-toast></p-toast>

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="table-body">
        <p-table [columns]="cols"
                 [value]="operators"
                 [lazy]="true"
                 (onLazyLoad)="handleLazyLoad($event)"
                 responsiveLayout="scroll" dataKey="OperatorId"
                 [paginator]="true"
                 [first]="query.skip"
                 [rows]="query.take"
                 [rowsPerPageOptions]="rowsPerPageOptions"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [loading]="loading">
            <ng-template pTemplate="caption">
                <div class="mt-4 mb-3 mr-4 flex justify-content-between">
                    <div class="table-head ml-3 mr-3">Tour Operators</div>
                    <div class="flex">
                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" class="search-input"
                                   [(ngModel)]="query.search" (input)="handleFilterChange()"
                                   placeholder="Search by name/email" />
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th class="text-center"
                        *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon *ngIf="query.sortField===col.field" [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-operator>
                <tr>
                    <td class="ui-resizable-column" *ngFor="let item of cols">
                        <ng-container *ngIf="item.field === 'Status'">
                            <span [class]="'status-badge ' + operator[item.field].toLowerCase()">{{operator[item.field]}}</span>
                        </ng-container>
                        <ng-container *ngIf="item.field === 'Action'">
                            <div class="flex gap-12">
                                <div class="flex action-btn reject" [ngClass]="{ 'btn-disabled': isBtnDisabled(operator, OperatorActionType.Reject) }"
                                     (click)="showActionModal(operator, OperatorActionType.Reject); $event.stopPropagation()">
                                    <img src="/XpressApp/assets/images/experience/icons/icon-reject.svg" width="18" height="18" alt="">
                                    <div>Reject</div>
                                </div>
                                <div class="mr-3 ml-3 flex action-btn request" (click)="showActionModal(operator, OperatorActionType.Request); $event.stopPropagation()">
                                    <img src="/XpressApp/assets/images/experience/icons/icon-request.svg" width="18" height="18" alt="">
                                    <div>Request Revision</div>
                                </div>
                                <div class="flex action-btn approve" [ngClass]="{ 'btn-disabled': isBtnDisabled(operator, OperatorActionType.Approve) }"
                                     (click)="showActionModal(operator, OperatorActionType.Approve); $event.stopPropagation()">
                                    <img src="/XpressApp/assets/images/experience/icons/icon-approve.svg" width="18" height="18" alt="">
                                    <div>Approve</div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="item.field !== 'Status' && item.field !== 'Action'">
                            <div class="ui-resizable-column text-center">{{operator[item.field]}}</div>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <div class="no-results-message text-center text-gray-600">
                    <img src="/XpressApp/assets/images/experience/icons/tour-operator.png" width="162" height="162" alt="">
                    <div class="no-operators mt-2">No Operators Found.</div>
                </div>
            </ng-template>

            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="operators.length > 0">
                    Showing {{query.skip + 1}} to {{query.skip + operators.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
